<template>
    <div class="flex flex-wrap items-center gap-4">
        <div class="component-box">
            <div class="flex items-center h-6 space-x-1">
                <i class="el-icon-money"></i>

                <p class="font-semibold">
                    {{ $t('common.total_balance') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{ total_balance }}
            </p>
        </div>

        <div class="h-fit p-1 bg-white rounded-full"></div>

        <div class="component-box">
            <div class="flex items-center h-6">
                <p class="font-semibold">
                    {{ $t('page.dashboard.spend_overview_lifetime') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{
                    p__renderMoneyByCurrency(
                        total_overview_lifetime
                            ? total_overview_lifetime.spend
                            : 0,
                        s__currency
                    )
                }}
            </p>
        </div>

        <div class="component-box">
            <div class="flex items-center h-6">
                <p class="font-semibold">
                    {{ $t('page.dashboard.impressions_overview_lifetime') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{
                    total_overview_lifetime
                        ? p__formatNumberHasCommas(
                              total_overview_lifetime.impressions
                          )
                        : 0
                }}
            </p>
        </div>

        <div class="component-box">
            <div class="flex items-center h-6">
                <p class="font-semibold">
                    {{ $t('page.dashboard.conversion_overview_lifetime') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{
                    total_overview_lifetime
                        ? p__formatNumberHasCommas(
                              total_overview_lifetime.conversion
                          )
                        : 0
                }}
            </p>
        </div>

        <div class="h-fit p-1 bg-white rounded-full"></div>

        <div class="component-box relative w-[200px]">
            <div class="flex items-center h-6">
                <p class="font-semibold">
                    {{ $t('page.dashboard.spend_overview_today') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{
                    p__renderMoneyByCurrency(
                        total_overview_today ? total_overview_today.spend : 0,
                        s__currency
                    )
                }}
            </p>

            <p class="bottom-1 left-5 text-desc-text absolute text-sm">
                {{
                    p__renderMoneyByCurrency(
                        total_overview_yesterday
                            ? total_overview_yesterday.spend
                            : 0,
                        s__currency
                    )
                }}
                ({{ $t('common.yesterday') }})
            </p>
        </div>

        <div class="component-box relative">
            <div class="flex items-center h-6">
                <p class="font-semibold">
                    {{ $t('page.dashboard.impressions_overview_today') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{
                    total_overview_today
                        ? p__formatNumberHasCommas(
                              total_overview_today.impressions
                          )
                        : 0
                }}
            </p>

            <p class="bottom-1 left-5 text-desc-text absolute text-sm">
                {{
                    total_overview_yesterday
                        ? p__formatNumberHasCommas(
                              total_overview_yesterday.impressions
                          )
                        : 0
                }}
                ({{ $t('common.yesterday') }})
            </p>
        </div>

        <div class="component-box relative">
            <div class="flex items-center h-6">
                <p class="font-semibold">
                    {{ $t('page.dashboard.conversion_overview_today') }}
                </p>
            </div>

            <p class="text-brand-atosa--light mt-2 text-xl font-semibold">
                {{ total_overview_today ? total_overview_today.conversion : 0 }}
            </p>

            <p class="bottom-1 left-5 text-desc-text absolute text-sm">
                {{
                    total_overview_yesterday
                        ? total_overview_yesterday.conversion
                        : 0
                }}
                ({{ $t('common.yesterday') }})
            </p>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { getSyncReport } from '@/services/atosa-tiktok-ads/reporting'

export default {
    props: ['ads_accounts', 'tiktok_account'],

    data() {
        return {
            total_balance: 0,
            total_overview_today: null,
            total_overview_yesterday: null,
            total_overview_lifetime: null
        }
    },

    computed: {
        s__currency() {
            return this.$store.getters.app.s__currency
        }
    },

    watch: {
        ads_accounts() {
            setTimeout(() => {
                this.fetchOverviewReportYesterday()

                this.fetchOverviewReportToday()

                this.fetchOverviewReportLifetime()
            }, 1234)

            if (this.ads_accounts.length) {
                const total = this.ads_accounts.reduce((acc, current) => {
                    acc += current.balance

                    return acc
                }, 0)
                this.total_balance = this.p__renderMoneyByCurrency(
                    total,
                    this.ads_accounts[0].currency
                )
            } else {
                this.total_balance = 0
            }
        }
    },

    mounted() {
        setTimeout(() => {
            this.fetchOverviewReportYesterday()

            this.fetchOverviewReportToday()

            this.fetchOverviewReportLifetime()
        }, 1234)
    },

    methods: {
        async fetchOverviewReport(
            start_date,
            end_date,
            query_lifetime = false
        ) {
            if (!this.tiktok_account || this.ads_accounts.length === 0) {
                return null
            }

            this.m__loading = true

            try {
                const response_list = []

                await Promise.all(
                    this.ads_accounts.map(async (item) => {
                        const data = {
                            report_type: 'BASIC',
                            metrics: this.p__basic_metrics,
                            start_date,
                            end_date,
                            service_type: 'AUCTION',
                            data_level: 'AUCTION_ADVERTISER',
                            advertiser_id: item.advertiser_id,
                            dimensions: ['advertiser_id'],
                            query_lifetime
                        }

                        const response = await getSyncReport(
                            this.tiktok_account.id,
                            data
                        )
                        if (
                            response.code === 0 &&
                            response.data.list.length > 0
                        ) {
                            response_list.push(response.data.list[0].metrics)
                        }
                    })
                )
                const result = this.p__calculateMetrics(response_list)

                this.m__loading = false

                return result
            } catch (error) {
                this.m__loading = false

                console.error(error)
            }

            return null
        },

        async fetchOverviewReportYesterday() {
            const start_date = moment().subtract(1, 'd').format('YYYY-MM-DD')
            const end_date = moment().subtract(1, 'd').format('YYYY-MM-DD')

            const response = await this.fetchOverviewReport(
                start_date,
                end_date
            )
            if (response) {
                this.total_overview_yesterday = response
            }
        },

        async fetchOverviewReportToday() {
            const start_date = moment().format('YYYY-MM-DD')
            const end_date = moment().format('YYYY-MM-DD')

            const response = await this.fetchOverviewReport(
                start_date,
                end_date
            )
            if (response) {
                this.total_overview_today = response
            }
        },

        async fetchOverviewReportLifetime() {
            const start_date = moment().format('YYYY-MM-DD')
            const end_date = moment().format('YYYY-MM-DD')
            const response = await this.fetchOverviewReport(
                start_date,
                end_date,
                true
            )
            if (response) {
                this.total_overview_lifetime = response
            }
        }
    }
}
</script>
